// Beside DrilldownMenu rather than in it: a module exporting components may export nothing else,
// or Vite's Fast Refresh gives up on the whole file — and the menus are edited constantly.

/**
 * For a flat menu (rows directly under the header, no sections): lands each row's icon column
 * on the header title's left edge — this 16px + RowIcon's own ml-1 = the header's px-5.
 * Pass to {@link import("./DrilldownMenu").Rows}.
 */
export const FLAT_MENU_ROWS_CLASS = "[--menu-row-inset:1rem]"
